import { Box } from "@mui/material";
import { ReactNode } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import AppIconButton from "../../Button/AppIconButton";
import AppIcon from "../../Icons/AppIcon";
import AppModal, { AppModalProps } from "../../Modals/AppModal";
import AppModalContent from "../../Modals/AppModalContent";
import AppTooltip from "../../Tooltip/AppTooltip";
import { PdfViewer, PdfViewerProps } from "./PdfViewer";

interface Props extends AppModalProps {
  viewerProps: PdfViewerProps;
  modalTitle?: ReactNode;
}

export function PdfViewerModal({ viewerProps, modalTitle, ...dialogProps }: Props) {
  return (
    <AppModal fullWidth maxWidth='md' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        {modalTitle || "View PDF"}{" "}
        <Box component='span'>
          {" "}
          <AppTooltip title='Download' placement='top'>
            <AppIconButton
              variant='text'
              size='small'
              onClick={() => {
                viewerProps.fileItem.download();
              }}
            >
              <AppIcon of='download' />
            </AppIconButton>
          </AppTooltip>
        </Box>
      </AppModalTitle>
      <AppModalContent>
        <PdfViewer {...viewerProps} />
      </AppModalContent>
    </AppModal>
  );
}
